import Header from "./Header"
import AdminBar from "../Admin/AdminBar";
import Breadcrumb from "./Breadcrumb";
import Menu from "./Menu"
import "./style.css"
export default function Basic(props) {

    const { children, menu, title } = props;

    return (
        <div>
            <AdminBar/>
            <Header/>
            <Breadcrumb title={title}/>
            <div className="container space-1 space-top-lg-0 space-bottom-lg-2 mt-lg-n10">
                <div className="row">
                    <div className="col-lg-3">
                        <div className="navbar-expand-lg navbar-expand-lg-collapse-block navbar-light">
                            <div
                                id="sidebarNav"
                                className="collapse navbar-collapse navbar-vertical"
                            >
                                <div className="card mb-5">
                                    <div className="card-body">
                                        <Menu menu={menu}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
}
